import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    countryLabel: 'In which country is your tax residence located?',
    countryPlaceholder: 'Select country...',
    description:
      'Your tax residence is the place where you spend most of your time and are likely to pay taxes.',
    helpDescription:
      'A tax number is a unique ID used to identify an individual for tax purposes and is mandatory for many declarations and procedures.',
    helpTitle: 'What is a Tax Identification Number?',
    nextButtonLabel: 'Next',
    taxIdentificationNumberInvalidFormat:
      'The TIN format is invalid (it must contain only numbers or letters)',
    taxIdentificationNumberLabel:
      'What is your Tax Identification Number ({taxResidencyCountry})?',
    taxIdentificationNumberPlaceholder: '0 123 456 456 789',
    title: 'In which other country is your tax residence located?',
  },
  fr: {
    countryLabel: 'Dans quel pays possédez-vous votre résidence fiscale\u00A0?',
    countryPlaceholder: 'Sélectionner le pays...',
    description:
      'La résidence fiscale est l’endroit où vous habitez la majorité du temps et êtes susceptible de payer des impôts.',
    helpDescription:
      'Le numéro fiscal est un identifiant unique destiné à identifier une personne lors de ses démarches fiscales. Il est obligatoire pour bon nombre de déclarations et démarches.',
    helpTitle: 'Qu’est-ce qu’un Numéro d’Identification Fiscale\u00A0?',
    nextButtonLabel: 'Continuer',
    taxIdentificationNumberInvalidFormat:
      'Le format du NIF est invalide (il ne doit comporter que des chiffres ou des lettres)',
    taxIdentificationNumberLabel:
      'Quel est votre Numéro d’Identification Fiscale ({taxResidencyCountry})\u00A0?',
    taxIdentificationNumberPlaceholder: '0 123 456 456 789',
    title: 'Dans quel autre pays avez-vous une résidence fiscale\u00A0?',
  },
} as const);

export default locales;
